import * as React from "react";

const IconNotificacoes = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="20"
    fill="none"
    viewBox="0 0 23 20"
    style={{ cursor: "pointer" }}
    {...props}
  >
    <path
      fill="var(--color-029)"
      d="M22.311 9.542c0 5.007-4.993 9.064-11.155 9.064-1.616 0-3.15-.28-4.536-.78-.518.379-1.364.897-2.366 1.333C3.208 19.612 1.95 20 .698 20a.697.697 0 0 1-.496-1.19l.013-.013a5.17 5.17 0 0 0 .27-.31c.179-.217.418-.54.662-.94.436-.724.85-1.674.933-2.741C.773 13.325 0 11.507 0 9.542.001 4.536 4.995.48 11.156.48c6.162 0 11.155 4.057 11.155 9.063"
    ></path>
  </svg>
);

export default IconNotificacoes;
